/* eslint class-methods-use-this: 0 */
import _forEach from 'lodash/forEach';

// constants
import { RED_PLANET, AUTOCOMPLETE, AUTOCOMPLETE_SELECTED } from './Constants';

// helpers
import MapUtils from './MapUtils';

class AutocompleteUtils {
  constructor() {
    // https://developers.google.com/places/supported_types
    this.FORBIDDEN_TYPES = ['natural_feature'];
  }

  /**
   * @description Clears DOM of autocomplete predictions
   *
   * @return {void}
   */
  clearPredictions() {
    const autocomplete = document.getElementById(AUTOCOMPLETE);
    while (autocomplete.firstChild) {
      autocomplete.removeChild(autocomplete.firstChild);
    }

    // slightly better cleanup than Google Maps autocomplete
    autocomplete.addEventListener('mouseover', () => {
      const places = document.getElementById(AUTOCOMPLETE).childNodes;
      const className = AUTOCOMPLETE_SELECTED;

      // eslint-disable-next-line arrow-parens
      _forEach(places, node => {
        const elem = node;
        if (elem.className === className) {
          elem.className = null;
          return false;
        }
        return true;
      });
    });
  }

  /**
   * @description Adds a class to the node selected by the user
   *
   * @param {Array} places - Collection of Places DOM nodes
   * @param {integer} selectedPlace - Index of the focused node
   *
   * @return {void}
   */
  selectPlace(places, selectedPlace) {
    const node = places;
    const placesLen = places.length;
    const className = AUTOCOMPLETE_SELECTED;

    if (node.length > 0) {
      if (selectedPlace === -1) {
        node[0].className = className;
      } else if (selectedPlace < placesLen) {
        node[selectedPlace].className = className;
      }
    }
  }

  /**
   * @description Adds a class to the node selected by the user
   *
   * @param {string} keyPressed - (ArrowUp|ArrowDown)
   *
   * @return {void}
   */
  highlightPlace(keyPressed) {
    const places = document.getElementById(AUTOCOMPLETE).childNodes;
    const className = AUTOCOMPLETE_SELECTED;
    let selectedPlace = -1;

    _forEach(places, (node, index) => {
      const elem = node;
      if (elem.className === className) {
        elem.className = null;
        if (keyPressed === 'ArrowDown') {
          selectedPlace = index + 1;
        } else if (keyPressed === 'ArrowUp') {
          selectedPlace = index - 1;
        }
        return false;
      }
      return true;
    });

    this.selectPlace(places, selectedPlace);
  }

  /**
   * @description Interfaces with Google Maps API to get details of the selected location
   *
   * @param {integer} fieldsLen - Number of fields in the application
   * @param {function} cb - Method to invoke if results have been found
   * @param {Object=} field - DOM node
   *
   * @return {void}
   */
  getPlace(fieldsLen, cb, field = false) {
    const { google } = window;

    try {
      const node = document.getElementsByClassName(AUTOCOMPLETE_SELECTED)[0];
      const address = field.value || node.innerText;

      const geocoder = MapUtils.getGeocoder();

      const sanatizedInput = address.toLowerCase();
      if (sanatizedInput === RED_PLANET.toLowerCase()) {
        const addressDetails = address;
        const place = field || document.activeElement;
        place.value = addressDetails;

        cb(place, addressDetails, fieldsLen);
      } else {
        geocoder.geocode({ address }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              const addressDetails = results[0];
              const place = field || document.activeElement;
              place.value = addressDetails.formatted_address;

              cb(place, addressDetails, fieldsLen);

              this.clearPredictions();
            }
          }
        });
      }
    } catch (e) {
      this.clearPredictions();
    }
  }

  /**
   * @description Get the address string from the focused autocomplete restule
   *
   * @param {Object=} field - DOM node
   *
   * @return {void}
   */
  getAddress(field = false) {
    const node = document.getElementsByClassName(AUTOCOMPLETE_SELECTED)[0];
    if (typeof node === 'undefined') {
      return '';
    }

    const address = field.value || node.innerText;
    return address;
  }
}

export default new AutocompleteUtils();
